import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../index.css";
import { LanguageInfo } from "src/config/types";
import { useLocation, useNavigate } from "react-router-dom";
interface Props {
  languageSupport: LanguageInfo;
}

function LanguageSwitch(props: Props) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {pathname} = location;
  const { languageSupport } = props;
  const changeLanguageHandler = (language: any) => {
    i18n.changeLanguage(language);
    localStorage.setItem('preferredLanguage', language);
    const toggledPath = language === "en" ? pathname.replace("/es","/en") : pathname.replace("/en","/es")
    navigate(toggledPath)
  };
  return (
    <div className="language-switch-container" role="group" aria-labelledby="preferred-language">
      <span id="preferred-language">{t(languageSupport.preferred)}</span>
      <Button
        onClick={() => changeLanguageHandler("en")}
        className={i18n.language === "en" ? "active" : ""}
        aria-pressed={i18n.language === "en"}
        lang="en"
      >
        {t(languageSupport.en)}
      </Button>
      <Button
        onClick={() => changeLanguageHandler("es")}
        className={i18n.language === "es" ? "active" : ""}
        aria-pressed={i18n.language === "es"}
        lang="es"
      >
        {" "}
        {t(languageSupport.es)}
      </Button>
    </div>
  );
}

export default LanguageSwitch;
